import { BadgeGreen } from "../../components/badge/Badge";
import { PendingBadge } from "../../components/badge/PendingBadge";

export const ConnectionStatusTag = ({
  connection,
}: {
  connection: { approved: boolean };
}) => {
  if (connection.approved) {
    return <BadgeGreen icon={"HANDSHAKE"}>Terms assigned</BadgeGreen>;
  }
  return <PendingBadge icon={"TIMER_SAND_EMPTY"}>Awaiting terms</PendingBadge>;
};
